import axios from 'axios'
import {getApiUrls} from "@/http/base.http";

export function getTrashScanSource(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}archival/trashscan/source/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function getTrashScanDestination(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}archival/trashscan/dest/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function hardDelete(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}archival/trashscan/file/hard/delete`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function confirmDelete(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}archival/trashscan/file/confirm/delete`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function fileRestore(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}archival/trashscan/file/restore`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
